import { render, staticRenderFns } from "./SnackbarAlert.vue?vue&type=template&id=add6a0e6&"
import script from "./SnackbarAlert.vue?vue&type=script&lang=ts&"
export * from "./SnackbarAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports